import { Config } from "../parhato2/src/shared/config";

// Specify the timezone you want to use
const BUFFER_OFFSET = 30;

const formatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Europe/Moscow",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
});

interface StaticDeliveryInterval {
  id: string;
  text: string;
  time_start: string;
  time_end: string;
}

export function getStaticDeliveryIntervals(isoDate?: string): StaticDeliveryInterval[] {
  const { deliveryIntervals, blockedIntervals } = Config.staticOrderData ?? {};

  if (!deliveryIntervals || !blockedIntervals) {
    return [];
  }

  // Get the current date and time in the specified timezone
  const now = new Date();
  const currentDateInTimezone = formatter.format(now).split(",")[0];

  const targetDate = isoDate || currentDateInTimezone;
  const isToday = currentDateInTimezone === targetDate;

  // Convert config intervals to the expected format
  let availableIntervals = deliveryIntervals?.map((interval) => ({
    id: interval.id,
    text: interval.text,
    time_start: interval.text.split(" - ")[0] + ":00",
    time_end: interval.text.split(" - ")[1] + ":00",
  }));

  // Filter out intervals that have passed today (with buffer)
  if (isToday) {
    const filterTime = new Date(now.getTime() + BUFFER_OFFSET * 60 * 1000);
    const currentTimeWithOffset = formatter.format(filterTime).split(",")[1].trim();

    availableIntervals = availableIntervals.filter((interval) => {
      return interval.time_start > currentTimeWithOffset;
    });
  }

  // Filter out blocked intervals
  const targetDateObj = new Date(targetDate);
  const targetDayOfWeek = targetDateObj.getDay();

  const filteredIntervals = availableIntervals.filter((interval) => {
    const isBlocked = blockedIntervals?.some((blocked) => {
      // Block by day of week (0 = Sunday, 6 = Saturday)
      if (blocked.dayOfWeek !== null && Number(blocked.dayOfWeek) === targetDayOfWeek) {
        return blocked.deliveryIntervalId === interval.id;
      }

      return false;
    });

    return !isBlocked;
  });

  return filteredIntervals;
}
